<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_31_1935)">
        <path d="M10 0.3125C4.64844 0.3125 0.3125 4.64844 0.3125 10C0.3125 15.3516 4.64844 19.6875 10 19.6875C15.3516 19.6875 19.6875 15.3516 19.6875 10C19.6875 4.64844 15.3516 0.3125 10 0.3125ZM4.84375 11.5625C4.58594 11.5625 4.375 11.3516 4.375 11.0938V8.90625C4.375 8.64844 4.58594 8.4375 4.84375 8.4375H15.1562C15.4141 8.4375 15.625 8.64844 15.625 8.90625V11.0938C15.625 11.3516 15.4141 11.5625 15.1562 11.5625H4.84375Z" fill="currentColor"/>
        </g>
        <defs>
        <clipPath id="clip0_31_1935">
        <rect width="20" height="20" fill="white"/>
        </clipPath>
        </defs>
    </svg>
</template>

